import { useState, useEffect, useRef } from "react";
import { hasCookiebotDialog, hasConsented, simplyClick } from "../../helpers";
import CookieBanner from "../CookieBanner";
import "./Footer.scss";

export const Footer = () => {
  const elRef = useRef(null);
  const [hide, setHide] = useState(true);

  useEffect(() => {
    const element = elRef.current;
    if (!element) return;

    const initText = element.textContent.trim();
    let previousText = element.textContent.trim();

    const observer = new MutationObserver(() => {
      const currentText = element.textContent.trim();
      if (currentText !== previousText && initText !== currentText) {
        simplyClick("translation_detected", {
          element: "footer_links",
          text: currentText.slice(0, 1000),
        });
        previousText = currentText;
      }
    });

    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    const timer = setTimeout(async () => {
      if (!hasConsented() && !hasCookiebotDialog()) {
        setHide(false);
      }
    }, 5000);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <div className="footer__wrapper">
        <div className={"footer-menu"} ref={elRef}>
          <div className={"block"}>
            <a href="/terms-of-use/" target={"_blank"} rel="noreferrer">
              Terms of Use
            </a>
            <a href="/privacy-policy/" target={"_blank"} rel="noreferrer">
              Privacy Policy
            </a>
            <a href="/cookie-policy/" target={"_blank"} rel="noreferrer">
              Cookie Policy
            </a>
          </div>
          <div className={"block"}>
            <a href="/refund-policy/" target={"_blank"} rel="noreferrer">
              Refund Policy
            </a>
            <a href="/billing-policy/" target={"_blank"} rel="noreferrer">
              Billing Policy
            </a>
            <a href="/consent-policy/" target={"_blank"} rel="noreferrer">
              Consent Policy
            </a>
            <a
              href="mailto: support@cupidlee.com"
              target={"_blank"}
              rel="noreferrer"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
      <CookieBanner hide={hide} />
    </>
  );
};
